import React, { useState } from "react";
import classNames from "classnames";

import { LargeTextHeader } from "../../common/LargeTextHeader";
import { MorphSticker } from "../../common/MorphSticker";

import styles from "./About.module.scss";
import { MorphSvg } from "../../common/MorphSvg";
import { MorphPaths } from "../../common/MorphSvg/paths";
// import Markdown from "markdown-to-jsx";
import { StretchCastle } from "../../Layout/StretchCastle";
import { Title } from "../../common/Title";
import { Newsletter } from "../../Layout/Newsletter";
import { CreditsFooter } from "../../Layout/CreditsFooter";
import { CreativeMarkdown } from "../../common/CreativeMarkdown";
import { LegalFooter } from "../../Layout/LegalFooter";

const Rows = [
  {
    icon: "Events",
    text: `It all began in June 2019 at a showcase held over a five day period when 20 arts and creative events took place across 13 local venues.`,
  },
  {
    icon: "Art",
    text: `The aim was to shine a light on the huge range of creativity there is at Elephant & Castle during the time of London College of Communication’s screen and design degree shows, which attract thousands of people. We wanted to use that upsurge in visitors as an opportunity to showcase the creative nature of Elephant & Castle.`,
  },
  {
    icon: "Jump",
    text: `Events ranged from family-friendly street dance classes to exhibitions of paintings, a live radio broadcast, club nights, plays and the degree show exhibitions.`,
  },
  {
    icon: "Closed",
    text: `When we reluctantly had to cancel plans for a showcase in 2020 due to COVID-19, this fast-tracked another ambition: creating a year round website that could help to support local arts and creative venues during this unprecedented period.`,
  },
  {
    icon: "Elephant",
    text: `Creative Elephant is here to give you the latest updates from venues as they evolve and adapt. Our aim is to promote the arts in Elephant and Castle area throughout the year and to connect the creative community with each other as well as with new and returning audiences.`,
  },
];

const About: React.FC<{ content: string }> = ({ content }) => {
  return (
    <>
      <LargeTextHeader className={styles.header}>{content}</LargeTextHeader>
      <MorphSticker
        startingLeft={0.15}
        startingTop={0.28}
        path="Castle"
        svgClassName={classNames(styles.sticker, styles.stickerOne)}
      />
      <MorphSticker
        startingLeft={0.4}
        startingTop={0.2}
        path="Elephant"
        svgClassName={classNames(styles.sticker, styles.stickerTwo)}
      />
      <MorphSticker
        startingLeft={0.7}
        startingTop={0.4}
        path="LiveMusic"
        svgClassName={classNames(styles.sticker, styles.stickerThree)}
      />
      <MorphSticker
        startingLeft={0.3}
        startingTop={0.7}
        path="Jump"
        svgClassName={classNames(styles.sticker, styles.stickerFour)}
      />

      <section className={styles.journey}>
        <div className={styles.wrapper}>
          <div className={styles.left} id="castle-match">
            <div className={classNames(styles.row, styles.rowCompact)}>
              <div className={styles.rowIcon}></div>
              <div className={styles.rowText}>
                <Title className="color-text">
                  The Creative Elephant Journey
                </Title>
              </div>
            </div>
            {Rows.map((row, idx) => (
              <div key={idx} className={styles.row}>
                <div className={styles.rowIcon}>
                  <MorphSvg
                    className={classNames(
                      styles.rowIconIcon,
                      styles[`rowIconIcon${row.icon}`]
                    )}
                    morph
                    morphObject={MorphPaths[row.icon]}
                  />
                </div>
                <div className={styles.rowText}>
                  <CreativeMarkdown options={{ forceBlock: true }}>
                    {row.text}
                  </CreativeMarkdown>
                </div>
              </div>
            ))}
          </div>
          <div className={styles.right}>
            <StretchCastle heightElementSelector="#castle-match" />
          </div>
        </div>
      </section>

      <Newsletter />

      <CreditsFooter />

      <LegalFooter />
    </>
  );
};

export { About };
